/* Elite Elixir: clearance helpers. Reads window.EE_CLR (printed by sections/ee-announcement.liquid). */
(function () {
  var C = window.EE_CLR || {};
  var SIZES = C.sizes || {};
  var ORDER = ['30ml', '60ml', '100ml'];

  /* 1. Deadline safety net: hides clearance messaging after the end time even if a page was cached. */
  function ended() { return !!C.endMs && Date.now() > C.endMs; }
  if (ended()) document.documentElement.classList.add('ee-clr-ended');

  function r(n) { return 'R' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function norm(v) { return String(v || '').toLowerCase().replace(/\s+/g, ''); }

  /* 2. Cart nudge: tells shoppers how close they are to the next multi-buy price. */
  function sizeOf(item) {
    if (item.product_type && norm(item.product_type) !== 'perfume') return null;
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) { var v = norm(opts[i].value); if (SIZES[v]) return v; }
    var t = norm(item.variant_title);
    return SIZES[t] ? t : null;
  }

  function lines(cart) {
    var counts = {};
    (cart.items || []).forEach(function (it) {
      var s = sizeOf(it);
      if (s) counts[s] = (counts[s] || 0) + it.quantity;
    });
    var out = [];
    ORDER.forEach(function (s) {
      var n = counts[s] || 0, p = SIZES[s] && SIZES[s].p;
      if (!n || !p) return;
      if (n === 1) out.push('Add 1 more <b>' + s + '</b> (any scent) and pay ' + r(p[1]) + ' for 2. Your second bottle costs just ' + r(p[1] - p[0]) + '.');
      else if (n === 2) out.push('Add 1 more <b>' + s + '</b> (any scent) and pay ' + r(p[2]) + ' for 3. Your third bottle costs just ' + r(p[2] - p[1]) + '.');
      else if (n === 3) out.push('<b>' + s + ' deal unlocked:</b> 3 bottles for ' + r(p[2]) + '.');
      else out.push('<b>' + s + ' deal unlocked:</b> 3 bottles for ' + r(p[2]) + ', extra ' + s + ' bottles at ' + r(p[0]) + ' each.');
    });
    return out;
  }

  var lastHtml = '';
  function paint() {
    var targets = document.querySelectorAll('#CartDrawer .drawer__footer, #main-cart-footer .cart__blocks');
    for (var i = 0; i < targets.length; i++) {
      var host = targets[i], box = host.querySelector(':scope > .ee-nudge');
      if (!lastHtml) { if (box) box.remove(); continue; }
      if (!box) { box = document.createElement('div'); box.className = 'ee-nudge'; box.setAttribute('data-ee-clearance', ''); host.insertBefore(box, host.firstChild); }
      if (box.innerHTML !== lastHtml) box.innerHTML = lastHtml;
    }
  }

  function refresh() {
    if (ended() || !C.tiersLive) return;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var l = lines(cart);
        lastHtml = l.length ? '<p>' + l.join('</p><p>') + '</p><p class="ee-nudge__trust">Mix any scents within a size. Deal applied automatically. Free delivery in SA.</p>' : '';
        paint();
      })
      .catch(function () {});
  }

  function watch() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        if (t) return;
        t = setTimeout(function () { t = null; paint(); }, 60);
      }).observe(drawer, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 120); }); } catch (e) {}
    }
    document.addEventListener('cart:updated', refresh);
    refresh();
  }

  /* 3. Product page: switch the clearance box and sticky bar when the size changes. */
  function selectedSize(scope) {
    var checked = scope.querySelector('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked');
    if (checked) return norm(checked.value);
    var sel = scope.querySelector('variant-selects select');
    if (sel) return norm(sel.value);
    return null;
  }

  function initPdp() {
    var box = document.querySelector('[data-ee-pdp]');
    var sticky = document.querySelector('[data-ee-sticky]');
    if (!box && !sticky) return;
    var scope = (box && box.closest('.product')) || document;

    function sync() {
      var s = selectedSize(scope);
      if (box) {
        var blocks = box.querySelectorAll('[data-size]'), shown = null;
        for (var i = 0; i < blocks.length; i++) {
          var on = norm(blocks[i].getAttribute('data-size')) === s;
          blocks[i].hidden = !on;
          if (on) shown = blocks[i];
        }
        if (!shown && blocks.length === 1) blocks[0].hidden = false;
      }
      if (sticky) {
        var priceEl = sticky.querySelector('[data-ee-sticky-price]');
        var src = box && box.querySelector('[data-size]:not([hidden])');
        if (priceEl && src && src.getAttribute('data-price')) priceEl.textContent = (s ? s + ' · ' : '') + src.getAttribute('data-price');
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(sync, 30);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      try { subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 60); }); } catch (e) {}
    }
    sync();

    if (!sticky) return;
    function mainBtn() { return document.querySelector('product-form [name="add"]'); }
    if (!mainBtn()) return;
    /* Move the bar to <body> so no animated/transformed parent can break position:fixed. */
    if (sticky.parentElement !== document.body) document.body.appendChild(sticky);
    var btn = sticky.querySelector('button');
    btn.addEventListener('click', function () {
      var b = mainBtn();
      if (!b) return;
      if (b.disabled) { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      b.click();
    });
    var waiting = false;
    function check() {
      waiting = false;
      var b = mainBtn();
      var on = !!b && b.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-on', on);
      document.body.classList.toggle('ee-sticky-on', on);
    }
    window.addEventListener('scroll', function () {
      if (waiting) return;
      waiting = true;
      setTimeout(check, 80);
    }, { passive: true });
    check();
  }

  function start() { watch(); initPdp(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();